import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useGetShowFilterFieldOptions = () => {
  const { data: config } = useInstanceConfigQuery();
  const specialFeatures = config?.custom_ui_labels?.specialFeatures ?? [];

  return !!specialFeatures?.includes("ENABLE_FILTER_FIELD_OPTIONS");
};
